import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useContext } from 'react';
import Popover from '../Popover/Popover.es.js';
import { PopoverContext } from '../Popover/PopoverContext.es.js';
import { List } from '../List/List.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var DropdownMenuComponent = function DropdownMenuComponent(_a) {
  var _b = _a,
      children = _b.children,
      props = __objRest(_b, ["children"]);

  return (
    /* @__PURE__ */
    React.createElement(Popover, __spreadValues({}, props), children)
  );
};

DropdownMenuComponent.displayName = "DropdownMenu";

var DropdownMenuTrigger = function DropdownMenuTrigger(_ref) {
  var children = _ref.children;
  return (
    /* @__PURE__ */
    React.createElement(Popover.Trigger, null, children)
  );
};

var DropdownMenuList = forwardRef(function (_c, ref) {
  var _d = _c,
      children = _d.children,
      rest = __objRest(_d, ["children"]);

  return (
    /* @__PURE__ */
    React.createElement(Popover.Content, __spreadValues({
      px: 0,
      py: "xs"
    }, rest),
    /* @__PURE__ */
    React.createElement(List, {
      ref: ref
    }, children))
  );
});
var DropdownMenuItem = forwardRef(function (_e, ref) {
  var _f = _e,
      children = _f.children,
      onClick = _f.onClick,
      _f$closeOnClick = _f.closeOnClick,
      closeOnClick = _f$closeOnClick === void 0 ? true : _f$closeOnClick,
      props = __objRest(_f, ["children", "onClick", "closeOnClick"]);

  var _useContext = useContext(PopoverContext),
      close = _useContext.close;

  var handleClick = function handleClick(event) {
    closeOnClick && close();
    onClick == null ? void 0 : onClick(event);
  };

  return (
    /* @__PURE__ */
    React.createElement(List.Item, __spreadValues({
      ref: ref,
      onClick: handleClick
    }, props), children)
  );
});
DropdownMenuItem.displayName = "DropdownMenu.Item";
var DropdownMenu = Object.assign(DropdownMenuComponent, {
  Trigger: DropdownMenuTrigger,
  List: DropdownMenuList,
  Item: DropdownMenuItem,
  Icon: List.ItemIcon,
  SecondaryAction: List.ItemSecondaryAction,
  Divider: List.Divider
});
var ResponsiveMenu = Object.assign(DropdownMenuComponent, {
  Trigger: DropdownMenuTrigger,
  List: DropdownMenuList,
  Item: DropdownMenuItem,
  Icon: List.ItemIcon,
  SecondaryAction: List.ItemSecondaryAction,
  Divider: List.Divider
});
export { DropdownMenu, ResponsiveMenu };